export const DEFAULT_TABLE_PAGE_SIZE = 10;
export const TABLE_PAGE_SIZE_OPTIONS = [10, 25, 50];

const toPositiveInteger = (value, fallback) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : fallback;
};

export const paginateTableRows = (
  sourceRows = [],
  requestedPage = 1,
  requestedPageSize = DEFAULT_TABLE_PAGE_SIZE,
) => {
  const rows = Array.isArray(sourceRows) ? sourceRows : [];
  const pageSize = toPositiveInteger(requestedPageSize, DEFAULT_TABLE_PAGE_SIZE);
  const total = rows.length;
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const page = Math.min(
    totalPages,
    toPositiveInteger(requestedPage, 1),
  );
  const startIndex = (page - 1) * pageSize;
  const endIndex = Math.min(startIndex + pageSize, total);

  return {
    rows: rows.slice(startIndex, endIndex),
    page,
    pageSize,
    total,
    totalPages,
    start: total === 0 ? 0 : startIndex + 1,
    end: endIndex,
  };
};
